import { Button } from "@/components/ui/button"
import { useAutoTranslation } from "@/entities"
import { DISCOVERED_TRANSLATION_KEYS } from "@/shared/constants"

export const ErrorPage = ({
  errorMessage,
  title,
}: {
  errorMessage: string
  title?: string
}) => {
  const { t } = useAutoTranslation()
  //IDEA add button to report the error with details
  return (
    <div className="bg-background flex min-h-screen items-center justify-center">
      <div className="space-y-4 p-8 text-center">
        <h1 className="text-destructive text-2xl font-bold">
          {title ?? t(DISCOVERED_TRANSLATION_KEYS.UNEXPECTED_ERROR)}
        </h1>
        <p className="text-muted-foreground">{errorMessage}</p>
        <Button onClick={() => window.location.reload()} variant="outline">
          {t(DISCOVERED_TRANSLATION_KEYS.RELOAD_PAGE)}
        </Button>
      </div>
    </div>
  )
}
